import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { getBatch } from '~/api/batches';
import { queryClient } from '~/App';
import { Batch } from '~/types/Batch';

const key = 'batch';

export const useGetBatch = (id?: string) => {
  return useQuery<Batch>([key, id], () => getBatch(id!).then((res) => res.data), {
    enabled: !!id,
    staleTime: Infinity,
  });
};

export const useRefreshBatchOnOpen = (id?: string) => {
  useEffect(() => {
    if (id) {
      queryClient.removeQueries([key, id]);
    }
  }, [id]);
};
